module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/banner03-385bec5584598d78d1932a33ed328bc8.png";